import { useTranslation } from 'react-i18next';
import { Icon } from '../../../ui/index.js';

/**
 * @aiPurpose Minimal close-only shell rendered while the detail query
 *   is in-flight. The shell intentionally does NOT carry the
 *   `russia-request-drawer-header` test id — that id belongs to the
 *   full header rendered by `RussiaRequestDrawerHeader` once
 *   `query.data` resolves, so async test queries do not race the
 *   loading-state fallback.
 */
export function RussiaRequestDrawerLoadingShell({
  id,
  onClose,
}: {
  id: string;
  onClose: () => void;
}) {
  const { t } = useTranslation(['russiaRequests', 'common']);
  return (
    <header
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '14px 18px',
        borderBottom: '1px solid var(--border-1)',
        flex: 'none',
      }}
    >
      <span
        style={{
          fontFamily: 'var(--font-mono)',
          fontSize: 13,
          fontWeight: 600,
          color: 'var(--fg-1)',
        }}
      >
        {id}
      </span>
      <span style={{ flex: 1 }} />
      <button
        type="button"
        onClick={onClose}
        aria-label={t('common:actions.close')}
        title={t('common:actions.close')}
        data-testid="russia-request-drawer-close"
        style={{
          width: 28,
          height: 28,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: 'none',
          background: 'transparent',
          borderRadius: 'var(--r-1)',
          cursor: 'pointer',
          color: 'var(--fg-2)',
        }}
      >
        <Icon name="x" size={18} />
      </button>
    </header>
  );
}
